import React, { useMemo } from "react";
export * from "./hooks";
export function toPx(value) {
  return Number.isFinite(value) ? `${value}px` : value;
}
export const sleep = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));
export const NumberFormat = new Intl.NumberFormat("en-us", {
  style: "currency",
  currency: "USD"
});
export function isValidNumber(number) {
  // disallow empty strings
  if (typeof number === "string" && number.trim() === "") {
    return false;
  }

  // disallow scientific notation
  if (typeof number === "string" && number.indexOf("e") !== -1) {
    return false;
  }
  try {
    const n = Number(number);
    return !Number.isNaN(n) && Number.isFinite(n);
  } catch (e) {
    return false;
  }
}
export const onKey = (key, callback, handler) => {
  return event => {
    if (event.which === key) {
      event.preventDefault();
      callback(event);
    }
    if (handler) {
      handler(event);
    }
  };
};
export const onSpace = (callback, handler) => onKey(32, callback, handler);
export const onEnter = (callback, handler) => onKey(13, callback, handler);
export const useIcon = icon => useMemo(() => {
  if (icon === undefined) return null;
  const isRenderable = ["string", "number", "boolean"].includes(typeof icon);
  return isRenderable || /*#__PURE__*/React.isValidElement(icon) ? icon : /*#__PURE__*/React.createElement(icon);
}, [icon]);
export const isIcon = node => {
  if (Object.prototype.hasOwnProperty.call(node.props, "viewBox")) {
    return true;
  }
  return false;
};
export const onRadioKeyPress = id => onSpace(() => document.querySelector(`#${id}`).click());
export let Sorting;
(function (Sorting) {
  Sorting[Sorting["Equal"] = 0] = "Equal";
  Sorting[Sorting["Greater"] = 1] = "Greater";
  Sorting[Sorting["Less"] = -1] = "Less";
})(Sorting || (Sorting = {}));
export let TIMELINE_POSITION;
(function (TIMELINE_POSITION) {
  TIMELINE_POSITION["LEFT"] = "left";
  TIMELINE_POSITION["RIGHT"] = "right";
  TIMELINE_POSITION["ALTERNATE"] = "alternate";
})(TIMELINE_POSITION || (TIMELINE_POSITION = {}));
export let TIMELINE_VARIANT;
(function (TIMELINE_VARIANT) {
  TIMELINE_VARIANT["PRIMARY"] = "primary";
  TIMELINE_VARIANT["DESTRUCTIVE"] = "destructive";
  TIMELINE_VARIANT["CONFIRM"] = "confirm";
  TIMELINE_VARIANT["WHITE"] = "white";
  TIMELINE_VARIANT["SHOP"] = "shop";
  TIMELINE_VARIANT["NONE"] = "";
})(TIMELINE_VARIANT || (TIMELINE_VARIANT = {}));
export function isTestEnv() {
  return typeof process === "object" && process.env.NODE_ENV === "test";
}
export const MAX_OPTIONS_HEIGHT = 254;
const INPUT_HEIGHT = 38;
const BORDER_HEIGHT = 1;
export const MAX_RESULTS_BOX_HEIGHT = MAX_OPTIONS_HEIGHT + INPUT_HEIGHT + BORDER_HEIGHT * 2;
//# sourceMappingURL=index.js.map